var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"d-block d-lg-none"},[_c('b-col',{staticClass:"p-0"},[_c('router-link',{attrs:{"to":"/landing"}},[_c('div',{staticClass:"nav-footer"},[_c('i',{staticClass:"icon-home vtd-icon-7",attrs:{"id":"home-icon"}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }